import React from 'react';
import PropTypes from 'prop-types';
import { useAppContext } from 'context/AppContext';
import { useSelector } from 'react-redux';
import { required } from 'form/validation';
import strings from 'localization/strings';
import paymentRecurrences from 'enums/paymentRecurrences';
import organizationTypes from 'enums/organizationTypes';

import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import GridSeparator from 'common/GridSeparator';
import { TextField, showErrorOnBlur } from 'mui-rff';
import TimePeriodPricesEditor from 'form/TimePeriodPricesEditor';
import MenuItem from '@material-ui/core/MenuItem';

const AdditionalServiceEditor = ({ fieldNamePrefix, actor }) => {
    const { appContext } = useAppContext();
    const authenticationContext = useSelector(state => state.authentication.context);

    const getName = suffix => suffix ? `${fieldNamePrefix}.${suffix}` : fieldNamePrefix;

    const eligibleForVatVisible = actor.organizationType === organizationTypes.business.key;

    return (
        <Box>
            <Grid container spacing={2}>

                <Grid item xs={12} md={6}>
                    <TextField
                        name={getName('description')}
                        label={strings.description}
                        size="small"
                        variant="outlined"
                        showError={showErrorOnBlur}
                        required
                        fieldProps={{ validate: required }}
                    />
                </Grid>

                <Grid item xs={12} md={6}>
                    <TextField
                        select
                        name={getName('paymentRecurrence')}
                        label={strings.paymentRecurrence}
                        size="small"
                        variant="outlined"
                    >
                        {
                            Object.values(paymentRecurrences).map(pt =>
                                <MenuItem key={pt.key} value={pt.key}>{pt.title}</MenuItem>
                            )
                        }
                    </TextField>
                </Grid>

            </Grid>

            <GridSeparator />

            <Grid container spacing={2}>
                <Grid item xs={12}>
                    <TimePeriodPricesEditor
                        fieldNamePrefix={getName('timePeriodPrices')}
                        amountLabel={strings.price}
                        currency={appContext.currency.code}
                        eligibleForVatVisible={eligibleForVatVisible}
                        commissionRateVisible={authenticationContext.isSuperAdmin}
                        timePeriodVisible
                    />
                </Grid>
            </Grid>
        </Box>
    );
};

AdditionalServiceEditor.propTypes = {
    fieldNamePrefix: PropTypes.string.isRequired,
    actor: PropTypes.object.isRequired
};

export default AdditionalServiceEditor;
